import { classnames } from 'tailwindcss-classnames';

import getThemeClasses from 'lib/util/theming';
import {
  ArticleHit,
  EmployeeHit,
  EventHit,
  EventListingHit,
  FileHit,
  PageHit,
  AnnouncementListingHit,
  ReportsHit,
  SearchListingHit,
  FeeScheduleHit,
  ProductListHit,
} from './Hits';
import { HitProps } from './Hits/_types';
import { IsNetworkSite } from 'lib/util/site-configuration';

const mapping = {
  employee: EmployeeHit,
  other: PageHit,
  event: EventHit,
  file: FileHit,
  article: ArticleHit,
  eventListing: EventListingHit,
  announcementListing: AnnouncementListingHit,
  report: ReportsHit,
  searchListing: SearchListingHit,
  feeSchedule: FeeScheduleHit,
  productList: ProductListHit,
};

const SearchHit = ({ hit, component }: HitProps) => {
  const isNetworkSite = IsNetworkSite();
  const isEventHit = ['event', 'eventListing'].indexOf(component || hit.type) !== -1;
  const Component = mapping[component || hit.type] || PageHit;
  const containerClassName = classnames({
    'mb-4': !isEventHit && !isNetworkSite,
  });

  return (
    <div className={containerClassName}>
      <div
        className={classnames(
          'py-6',
          'px-6',
          'md:px-10',
          'rounded-lg',
          getThemeClasses('theme-white')
        )}
      >
        <Component hit={hit} />
      </div>
    </div>
  );
};

export default SearchHit;
